/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1SendMessagePayload
 */
export interface V1SendMessagePayload {
    /**
     *
     */
    text: string
}

/**
 * Check if a given object implements the V1SendMessagePayload interface.
 */
export function instanceOfV1SendMessagePayload(
    value: object
): value is V1SendMessagePayload {
    if (!('text' in value) || value['text'] === undefined) return false
    return true
}

export function V1SendMessagePayloadFromJSON(json: any): V1SendMessagePayload {
    return V1SendMessagePayloadFromJSONTyped(json, false)
}

export function V1SendMessagePayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1SendMessagePayload {
    if (json == null) {
        return json
    }
    return {
        text: json['text']
    }
}

export function V1SendMessagePayloadToJSON(json: any): V1SendMessagePayload {
    return V1SendMessagePayloadToJSONTyped(json, false)
}

export function V1SendMessagePayloadToJSONTyped(
    value?: V1SendMessagePayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        text: value['text']
    }
}
